import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import classes from './Heading.module.scss';

const Heading = ({ size = 3, children, className, weight = 'b', ...other }) => {
  return React.createElement(
    `h${size}`,
    {
      className: cn(
        classes.base,
        classes[`heading${size}`],
        weight === 'b' ? classes.semibold : '',
        weight === 'm' ? classes.medium : '',
        weight === 'r' ? classes.regular : '',
        className
      ),
      ...other
    },
    children
  );
};

Heading.propTypes = {
  size: PropTypes.oneOf([1, 2, 3, 4, 5, 6]),
  weight: PropTypes.oneOf(['r', 'm', 'b']),
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node)
  ]),
  className: PropTypes.string
};

export default Heading;
